import './App.css';
import React, {
	useEffect
} from 'react';
// import Pro_city_data from './mockData';
import Modal from './components/modal/Modal'



    

function App() {
	const [tips, setTips] = React.useState('')
	const [status, setStatus] = React.useState('')
	const [visible, setVisible] = React.useState(false)
	const [nameShow, setNameShow] = React.useState(false)
	const handleClick = () => {
		setVisible(!visible)
		setNameShow(!nameShow)
	}
	const [handleClose, handleOk, handleCancel] = React.useMemo(() => {
		const Ok = () => console.log()
		const Close = () => setVisible(false)
		const Cancel = () => console.log()
		return [Close, Ok, Cancel]
	}, [])

	const [citylist, setCitylist] = React.useState([]);
	// let citylist = [];
	// let Pro_city_data =[];
	useEffect(() => {
		fetch('https://campaigns.volvocars.com.cn/campaign/statistic/api/web/v1/apiservice/regions/all-list.php', {
				method: 'GET',
			})
			.then((res) => {
				res.json().then((state) => {
					console.log(state)
					if (state.code == 0) {
						setCitylist(state.data)
					}
				});
			})
			.catch((e) => {
				console.log(e);
			});
	}, []);
	const [name, setName] = React.useState('');
	const [sex, setSex] = React.useState(1);
	const [province, setProvince] = React.useState('0');
	const [provinceid, setProvinceid] = React.useState('0');
	const [city, setCity] = React.useState('0');
	const [cityid, setCityid] = React.useState('0');
	const [phone, setPhone] = React.useState('');
	const [checked, setChecked] = React.useState(false);
	const [citys, setCitys] = React.useState([]);
	const apiUrl = 'https://campaigns.volvocars.com.cn/campaign/statistic/api/web/v1/apistatistic/drivers/save.php';
	var pList = (window.location.search.substring(1)).split("&");
	let peoList = [];
	for (let i in pList) {
		if (pList[i].indexOf('utm_source') != -1) {
			peoList.push(pList[i]);
		}
		if (pList[i].indexOf('utm_medium') != -1) {
			peoList.push(pList[i]);
		}
		if (pList[i].indexOf('utm_campaign') != -1) {
			peoList.push(pList[i]);
		}
		if (pList[i].indexOf('utm_content') != -1) {
			peoList.push(pList[i]);
		}
		if (pList[i].indexOf('utm_term') != -1) {
			peoList.push(pList[i]);
		}
		if (pList[i].indexOf('sourceApplicationInformation') != -1) {
			peoList.push(pList[i]);
		}
	}
	if (peoList.length > 0) {

	} else {
		peoList = [''];
	}
	pList = peoList;
	var definedCookie = window.sessionStorage;
	// url为准
	var cookieString = "[";
	for (var i = 0; i < pList.length; i++) {
		cookieString += "{\"" + pList[i].split("=")[0] + "\":\"" + pList[i].split("=")[1] + "\"},";
	}
	definedCookie["defined_session"] = cookieString.substring(0, cookieString.length - 1) + "]";
	//end
	if (typeof(definedCookie["defined_session"]) == "undefined" || definedCookie["defined_session"] == "kong") {
		var cookieString = "[";
		if (pList.length == 1) {
			if (document.referrer.match("baidu.com") != null) {
				definedCookie["defined_session"] =
					"[{utm_campaign:\"organic\"},{utm_source:\"baidu\"},{utm_medium:\"organic\"}]";
			} else {
				definedCookie["defined_session"] = "kong";
			}
		} else {
			for (var i = 0; i < pList.length; i++) {
				cookieString += "{\"" + pList[i].split("=")[0] + "\":\"" + pList[i].split("=")[1] + "\"},";
			}
			definedCookie["defined_session"] = cookieString.substring(0, cookieString.length - 1) + "]";
		}
	} else {
		if (pList.length > 1) {
			var definedCookie = window.sessionStorage;
			var cookieString = "[";
			for (var i = 0; i < pList.length; i++) {
				cookieString += "{\"" + pList[i].split("=")[0] + "\":\"" + pList[i].split("=")[1] + "\"},";
			}
			definedCookie["defined_session"] = cookieString.substring(0, cookieString.length - 1) + "]";
		}
	}

	function interceptParameters(e) {
		let url = decodeURIComponent(e)
		let arr = url.indexOf('?') > -1 ? url.split('?') : [] // 如有多个？拼接参数
		let object = {};
		for (let j = 0; j < arr.length; j++) {
			let strs = arr[j].split("&");
			for (let i = 0; i < strs.length; i++) {
				if (strs[i].indexOf("=") > -1) object[strs[i].split("=")[0]] = strs[i].split("=")[1]
			}
		}
		// console.log('**url**',url)
		// console.log('**urlObj**',object)
		return object
	};
	// 秒针埋点
	function mdClick(e, i) {
		console.log('---', e, i);
		window.stm_clicki('send', 'event', 'EX30 Cross Country KMU', e, i, 1);
	}
	
	
	function prClick(e, i) {
		window.stm_clicki('send', 'event', 'EX30 Cross Country KMU', e, i, 1);
		window.open('https://www.volvocars.com.cn/zh-cn/v/legal/test-drive-privacy', "_blank");
	}

	function onChecked(e) {
		console.log('---', e);
		setChecked(!e)
		window.stm_clicki('send', 'event', 'EX30 Cross Country KMU', '点击', '点击同意隐私政策', 1);

	}

	function selcity(e) {
		let str = e.target.value;
		setProvince(e.target.value);
		if (e.target.selectedIndex == 0) {
			setCitys([]);
		} else {
			setProvinceid(citylist[e.target.selectedIndex - 1].value);
			citylist.map((item) => {
				if (item.p === e.target.value) {
					setCitys(item.c);
					if (str && str.substring(str.length - 1, str.length) == '市') {
						let i = item.c.length ? item.c[0] : {}
						setCity(i.n);
						setCityid(i.value);
					} else {
						setCity(0);
						setCityid('');
					}
				}
			});
		}
	}

	function selcityTwo(e) {
		if (e.target.selectedIndex == 0 && e.target.value == 0) {
			setCity(0);
			setCityid(citys[e.target.selectedIndex].value);
		} else {
			setCity(e.target.value);
			setCityid(citys[e.target.selectedIndex - 1].value);
		}
	}

	function submintform() {
		const pattern = /^1[3456789]\d{9}$/;
		window.stm_clicki('send', 'event', 'EX30 Cross Country KMU', '点击', '点击提交', 1);
		let test = name.trim();
		
		if (name === '' || test.length == 0) {
			setTips('请填写您的姓名');
			setStatus('普通');
			setVisible(!visible);
			setNameShow(!nameShow);
			return false;
		}else if (name.length > 20) {
			setTips('姓名不能超过20个字符');
			setStatus('普通');
			setVisible(!visible);
			setNameShow(!nameShow);
			return false;
		}else if (sex === 0) {
			setTips('请选择性别');
			setStatus('普通');
			setVisible(!visible);
			setNameShow(!nameShow);
			return false;
		}else if (phone === '') {
			setTips('请填写您的电话号码');
			setStatus('普通');
			setVisible(!visible);
			setNameShow(!nameShow);
			return false;
		} else if (pattern.test(phone) === false) {
			setTips('请输入正确的号码');
			setStatus('普通');
			setVisible(!visible);
			setNameShow(!nameShow);
			return false;
		} else if (province === '0') {
			setTips('请选择您的省份');
			setStatus('普通');
			setVisible(!visible);
			setNameShow(!nameShow);
			return false;
		} else if (city === '0') {
			setTips('请选择您的城市/区');
			setStatus('普通');
			setVisible(!visible);
			setNameShow(!nameShow);
			return false;
		} else if (!checked) {
			setStatus('隐私政策');
			setVisible(!visible);
			setNameShow(!nameShow);
			return false;
		}  

		let utm_campaigns = '2507EX30CCKMU';
		let utm_sources = 'EX30CCKMU';
		var textURL =
			apiUrl +
			'?username=' + name +
			'&userphone=' + phone +
			'&utm_campaign=' + utm_campaigns +
			'&utm_source=' + utm_sources +
			'&cartype=ex30cc&gender=' + sex +
			'&province=' + province +
			'&city=' + city +
			'&province_id=' + provinceid +
			'&city_id=' + cityid +
			'&refereral=' + encodeURIComponent(window.location.href);
		console.log('textURL', textURL);
		var definedCookie = window.sessionStorage;
		if (definedCookie['defined_session'] === 'kong') {
			textURL += '&sourceApplicationInformation=普通&utm_campaign=普通&utm_source=普通&utm_content=普通&utm_medium=普通';
		} else {
			if (definedCookie.length > 0) {
				const defined_session = eval(definedCookie['defined_session']);

				if (interceptParameters(textURL).utm_source && interceptParameters(textURL).utm_campaign) {
					defined_session.push({
						utm_source: interceptParameters(textURL).utm_source,
					})
					defined_session.push({
						utm_campaign: interceptParameters(textURL).utm_campaign,
					})
				}

				if (defined_session && defined_session.length > 0) {
					for (var i = 0; i < defined_session.length; i++) {
						for (var key in defined_session[i]) {
							textURL += '&';
							textURL += key + '=' + defined_session[i][key];
						}
					}
				}
			}
		}
		fetch(textURL, {
				method: 'POST',
			})
			.then((res) => {
				res.json().then((state) => {
					if (state.code === 0) {
						setName('');
						setSex(1);
						setProvince('0');
						setCity('0');
						setPhone('');
						setChecked(false);
						setCitys([]);
						// window._hmt.push(['_trackEvent', 'lead_form-B2C-KMU-S60', 'Webform', 'success']);
						window.stm_clicki('send', 'event', 'EX30 Cross Country KMU', '点击', '提交成功', 1);
						setTips('提交成功！');
						setStatus('普通');
						setVisible(!visible);
						setNameShow(!nameShow);
					} else {
						setTips('提交失败！');
						setStatus('普通');
						setVisible(!visible);
						setNameShow(!nameShow);
						window.stm_clicki('send', 'event', 'EX30 Cross Country KMU', '点击', '提交成功', 1);
					}
				});
			})
			.catch((e) => {
				console.log(e);
			});
	}

	function selsex(val) {
		setSex(val)
	}
	return (
      <div className="App" id="appContent">
      	<div className="logo">
      		<a href="https://www.volvocars.com.cn/zh-cn" onClick={ () => mdClick('点击','点击左上角VOLVO')}>
      			<img src="https://www.volvocars.com/static/shared/images/volvo-spread-wordmark.svg"></img>
      		</a>
      	</div>	
		<div className="mob-banner-seize"></div>
		<div className='mob-banner-con'></div>
		<img className="mob-banner" id="mobCon"
			src="https://campaigns-static.volvocars.com.cn/image/images/ex30-kmu-mobile-banner_250703.jpg" />
			
		<div className="drive-pc" id="driveForm">
			<div className='drive-con'>
				<img class="text-pc17"
					src="https://campaigns-static.volvocars.com.cn/image/images/ex30-kmu-text-01_03_2.png" />
				<img class="text-pc17-mob"
					src="https://campaigns-static.volvocars.com.cn/image/images/ex30-kmu-mob-text-01_03_3.png" />
				<div className="wrap">
		  		<div className="inline">
		  			<div>
		  				<input 
		  					onClick={ () => mdClick('点击','点击填写姓名')} 
		  					placeholder="请填写您的姓名*"
		  					value={name}
		  					onChange={(e) => setName(e.target.value)}
		  				/>
		  			</div>
		  			<div>
		  				<input 
		  					onClick={ () => mdClick('点击','点击填写电话号码')} 
		  					placeholder="请填写您的电话号码*"
		  					type="text"
		  					value={phone}
		  					onChange={(e) => setPhone(e.target.value)}
		  				/>
		  			</div>
		  			<div className="province">
		  			  <select value={province} onChange={selcity} onClick={ () => mdClick('点击','点击填写省份')} >
		  			    <option value="0">请选择您的省份*</option>
		  			    {citylist.map((item, index) => {
		  			      return (
		  			        <option key={index} value={item.p}>
		  			          {item.p}
		  			        </option>
		  			      );
		  			    })}
		  			  </select>
		  			</div>
		  			<div>
		  			  <select 
		  					onClick={ () => mdClick('点击','点击填写城市/区')} 
		  			    value={city}
		  			    onChange={selcityTwo}
		  					  					// onChange={(e) => {
		  			    //   setCity(e.target.value);
		  			    //   setCityid(citys[e.target.selectedIndex - 1].value);
		  			    // }}
						style={{ marginBottom: '0px' }}
		  			  >
		  			    <option value="0">请选择您的城市/区*</option>
		  			    {citys.map((item, index) => {
		  			      return (
		  			        <option key={index} value={item.n}>
		  			          {item.n}
		  			        </option>
		  			      );
		  			    })}
		  			  </select>
		  			</div>
		  		</div>
				<div className="text_true">以上星号（*）标注部分为必填项。</div>
				<div className="text">
				<div className="hint">
					<i className={checked ? 'checkedBg' : ''} onClick={()=>onChecked(checked)}></i>
					<span>我已阅读并同意沃尔沃汽车
					<a onClick={ () => mdClick('点击','点击查看隐私政策')} 
					href="https://www.volvocars.com.cn/zh-cn/v/legal/test-drive-privacy"
					rel="noopener noreferrer"
					target="_blank"
					>
					《预约试驾隐私政策》
					</a></span>
					
				</div>
				<div className="btn"><button onClick={submintform}>提 交</button></div>
				</div>
			</div>
		  </div>
		  <div class="pc17-tips">以中国大陆市场实际销售为准</div>
		</div>
		
        <Modal
              onCancel={handleCancel}
              onClose={handleClose}
              onOk={handleOk}
              visible={visible}
              width={302}
        			state={status}
           >
        		 <div className="feel" >
        		     {tips}
        		 </div>
        </Modal>
      </div>
	);
}

export default App;